/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Status_UpdatedInputs */

const en_applications_status_updated = /** @type {(inputs: Applications_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status updated`)
};

const de_applications_status_updated = /** @type {(inputs: Applications_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status aktualisiert`)
};

const fr_applications_status_updated = /** @type {(inputs: Applications_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut mis à jour`)
};

const es_applications_status_updated = /** @type {(inputs: Applications_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado actualizado`)
};

const it_applications_status_updated = /** @type {(inputs: Applications_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato aggiornato`)
};

const nl_applications_status_updated = /** @type {(inputs: Applications_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status bijgewerkt`)
};

const pl_applications_status_updated = /** @type {(inputs: Applications_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status zaktualizowany`)
};

const fi_applications_status_updated = /** @type {(inputs: Applications_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tila päivitetty`)
};

const da_applications_status_updated = /** @type {(inputs: Applications_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status opdateret`)
};

const sv_applications_status_updated = /** @type {(inputs: Applications_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status uppdaterad`)
};

/**
* | output |
* | --- |
* | "Status updated" |
*
* @param {Applications_Status_UpdatedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_status_updated = /** @type {((inputs?: Applications_Status_UpdatedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Status_UpdatedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_status_updated(inputs)
	if (locale === "fr") return fr_applications_status_updated(inputs)
	if (locale === "es") return es_applications_status_updated(inputs)
	if (locale === "it") return it_applications_status_updated(inputs)
	if (locale === "nl") return nl_applications_status_updated(inputs)
	if (locale === "pl") return pl_applications_status_updated(inputs)
	if (locale === "fi") return fi_applications_status_updated(inputs)
	if (locale === "da") return da_applications_status_updated(inputs)
	if (locale === "sv") return sv_applications_status_updated(inputs)
	return en_applications_status_updated(inputs)
});